import CharactersParagraph from './CharactersParagraph';
export default CharactersParagraph;